<template>
  <div class="basic-link">
    <!-- location -->
    <a v-if="href" :href="href"><slot /></a>

    <a v-else @click="$emit('click')"><slot /></a>
  </div>
</template>

<script>
export default {
  name: 'BasicLink',
  props: {
    href: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style lang="sass" scoped>
.basic-link
  a
    font: $font-basic
    text-decoration: underline
</style>
